export default {
  /** 分页查询油罐库存列表 */
  selectYgInventoryByPage: '/ygsjzs/ygInventory/selectYgInventoryByPage',
  /** 查询油罐库存详情 */
  selectYgInventoryByYgId: '/ygsjzs/ygInventory/selectYgInventoryByYgId',
  /** 新增油罐库存记录 */
  insertYgInventory: '/ygsjzs/ygInventory/insertYgInventory',
  /** 删除油罐库存记录 */
  deleteYgInventory: '/ygsjzs/ygInventory/deleteYgInventory',
  /** 修改油罐库存记录 */
  updateYgInventory: '/ygsjzs/ygInventory/updateYgInventory',
  // 审批
  approveYgInventory: '/ygsjzs/ygInventory/approveYgInventory',
  // 修改发车状态
  updateYgInventoryState: '/ygsjzs/ygInventory/updateYgInventoryState',
  // 导出
  exportYgInventoryReport: '/ygsjzs/ygInventory/exportYgInventoryReport',
  // 新增自由单
  insertYgInventoryJl: '/ygsjzs/ygInventory/insertYgInventoryJl'
}
